(() => {
  angular
    .module('gm.common.services')
    .factory('ModalOverlay', ModalOverlayFactory);

  function ModalOverlayFactory(
    $rootScope,
    $document,
    $window
  ) {
    'ngInject';

    let activated = false;
    const service = {
      init,
    };

    init();
    return service;

    function init() {
      if (!activated) {
        activated = true;
        let openModals = 0;
        let scrollTop;

        const $winEl = $window.$($window);
        const overlay = angular.element($document[0].getElementsByClassName('modal-overlay'));

        $rootScope.$on('modal:opened', (_event, overlayType) => {
          if (openModals === 0) {
            overlay.addClass('modal-overlay--active');
            scrollTop = $winEl.scrollTop();
            $winEl.scrollTop(0);
            if (overlayType === 'dark') {
              $rootScope.darkOverlay = true;
            }
            overlay.on('click', notifyOverlayClick);
          }
          openModals += 1;
        });

        $rootScope.$on('modal:closed', (_event, overlayType) => {
          openModals -= 1;
          if (openModals === 0) {
            overlay.removeClass('modal-overlay--active');
            $winEl.scrollTop(scrollTop);
            if (overlayType === 'dark') {
              $rootScope.darkOverlay = false;
            }
            overlay.off('click', notifyOverlayClick);
          }
        });
      }
    }
    function notifyOverlayClick() {
      $rootScope.$broadcast('modal:overlay:click');
    }
  }
})();
